import { render, staticRenderFns } from "./profileHandler.vue?vue&type=template&id=6cafa92f"
import script from "./profileHandler.vue?vue&type=script&lang=js"
export * from "./profileHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports